
import { PJAxios, setOfflineBundles, useCoreContext, useGetText, usePJStore } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState } from 'react';
import { flushCache } from '../../../api/ChatbotApi';
import isFilled from '../../Utils';

function Menu(props) {

    const [name_it, setName_it] = useState(null);
    const [name_en, setName_en] = useState(null);
    const [descrizione_it, setDescrizione_it] = useState(null);
    const [descrizione_en, setDescrizione_en] = useState(null);

    const [allowAttachments, setAllowAttachments] = useState(null);
    const [loginRequired, setLoginRequired] = useState(null);
    const [visibility, setVisibility] = useState(null);

    const [nodeType, setNodeType] = useState(null);

    const [modifiedNodes, setModifiedNodes] = useState([]);
    const [loading, setLoading] = useState(false);

    const getText = useGetText();
    const dbTest = usePJStore((state) => state.appInfo_dbTest);
    const { storage } = usePJStore((state) => state.storage)

    const bundles = useCoreContext((state) => state.i18n.bundles)

    useEffect(() => {
        let bundle2 = props.selectedNode.title.replace(/TITLE/g, 'SUBTITLE')

        if (props.selectedNode != null) {
            setNodeType(props.selectedNode.nodeType);


            if (props.selectedNode.nodeType === "M" || props.selectedNode.nodeType === "S") {
                const italianTitle = bundles.it[props.selectedNode.title];
                const englishTitle = bundles.en[props.selectedNode.title];

                const sNodeId = props.selectedNode.title.replace(/TITLE/g, 'SUBTITLE');
                 //console.log("sNodeId", sNodeId);
                const italiansubtitle = bundles.it[sNodeId];
                const englishsubtitle = bundles.en[sNodeId];

                setName_it(italianTitle);
                setName_en(englishTitle);
                setDescrizione_it(italiansubtitle);
                setDescrizione_en(englishsubtitle);
                setVisibility(!props.selectedNode.hidden);
            }

            if (props.selectedNode.nodeType === "M") {
                setAllowAttachments(props.selectedNode.attachments);
                setLoginRequired(props.selectedNode.authRequired);

            }

            setTimeout(() => {
                props.onNodeLoaded();
            }, 500);

        }
    }, [props.selectedNode]);

    useEffect((e) => {
        var modifiedItem = { is_new: false, id_item: props.selectedNode.idItem, id_element: "nomeramo_it", op_type: "mod_el", obj_type: "menu", new_val: name_it }
        props.onModificationReceived(modifiedItem);
    }, [name_it]);

    useEffect((e) => {
        var modifiedItem = { is_new: false, id_item: props.selectedNode.idItem, id_element: "nomeramo_en", op_type: "mod_el", obj_type: "menu", new_val: name_en }
        props.onModificationReceived(modifiedItem);
    }, [name_en]);

    useEffect((e) => {
        var modifiedItem = { is_new: false, id_item: props.selectedNode.idItem, id_element: "descrizioneramo_it", op_type: "mod_el", obj_type: "menu", new_val: descrizione_it }
        props.onModificationReceived(modifiedItem);
    }, [descrizione_it]);

    useEffect((e) => {
        var modifiedItem = { is_new: false, id_item: props.selectedNode.idItem, id_element: "descrizioneramo_en", op_type: "mod_el", obj_type: "menu", new_val: descrizione_en }
        props.onModificationReceived(modifiedItem);
    }, [descrizione_en]);

    useEffect((e) => {
        var modifiedItem = { is_new: false, id_item: props.selectedNode.idItem, id_element: "allegati", op_type: "mod_el", obj_type: "menu", new_val: allowAttachments }
        props.onModificationReceived(modifiedItem);
    }, [allowAttachments]);

    useEffect((e) => {
        var modifiedItem = { is_new: false, id_item: props.selectedNode.idItem, id_element: "login", op_type: "mod_el", obj_type: "menu", new_val: loginRequired }
        props.onModificationReceived(modifiedItem);
    }, [loginRequired]);

    useEffect((e) => {
        var modifiedItem = { is_new: false, id_item: props.selectedNode.idItem, id_element: "nascondiramo", op_type: "mod_el", obj_type: "menu", new_val: visibility }
        props.onModificationReceived(modifiedItem);
    }, [visibility]);

    const salva = () => {
        let modifiedItems = [];

        modifiedItems.push({ is_new: false, id_item: props.selectedNode.idItem, id_element: "nomeramo_it", op_type: "mod_el", obj_type: "menu", new_val: name_it });
        modifiedItems.push({ is_new: false, id_item: props.selectedNode.idItem, id_element: "nomeramo_en", op_type: "mod_el", obj_type: "menu", new_val: name_en });
        modifiedItems.push({ is_new: false, id_item: props.selectedNode.idItem, id_element: "descrizioneramo_it", op_type: "mod_el", obj_type: "menu", new_val: descrizione_it });
        modifiedItems.push({ is_new: false, id_item: props.selectedNode.idItem, id_element: "descrizioneramo_en", op_type: "mod_el", obj_type: "menu", new_val: descrizione_en });
        setModifiedNodes(modifiedItems);

    }

    const onSave = (tematica, outcome) => {
        props.onSave(tematica, outcome);
    }

    useEffect((e) => {
        if (modifiedNodes.length > 0) {
            salvaTutto();
        }
    }, [modifiedNodes]);

    const aggiornaBundles = (nodes) => {

        let valueIt = "";
        let valueEn = "";
        let value2It = "";
        let value2En = "";
        let bundle = props.selectedNode.title;
        let bundle2 = bundle.replace(/TITLE/g, 'SUBTITLE');

        nodes.forEach(node => {
             
            if (node.id_element == "nomeramo_it") {
                valueIt = node.new_val
            } else if (node.id_element == "nomeramo_en") {
                valueEn = node.new_val
            } else if (node.id_element == "descrizioneramo_it") {
                value2It = node.new_val
            } else if (node.id_element == "descrizioneramo_en") {
                value2En = node.new_val
            }


        });

         
        setOfflineBundles({ it: { [bundle2]: value2It }, en: { [bundle2]: value2En } })
        setOfflineBundles({ it: { [bundle]: valueIt }, en: { [bundle]: valueEn } })
        //console.log(({ it: { [bundle.replace(/title/g, 'subtitle')]: value2It }, en: { [bundle.replace(/title/g, 'subtitle')]: value2En } }))

    }



    const salvaTutto = () => {
        setLoading(true);
         //console.log("modifiedNodes", modifiedNodes)
        PJAxios().post('/gestioneConfigurazioni/salvaTutto', { operazioni: modifiedNodes, idConfig: props.tematica.id_config }).then((res) => {
            aggiornaBundles(modifiedNodes)
            setLoading(false);
            onSave(props.tematica, true);
            setModifiedNodes([]);
            flushCache(dbTest);





        });

    }

    const confirmOperation = (event) => {
        props.onConfirmOperation(event)
    }

    const validateForm = () => {
        return isFilled(name_en) && isFilled(name_it) && !isFilled(descrizione_it) && !isFilled(descrizione_en) || (isFilled(name_en) && isFilled(name_it) && isFilled(descrizione_it) && isFilled(descrizione_en))
    }

    return (
        <>
            {loading &&
                <ProgressSpinner />
            }

            {!loading && //nodeLoaded &&
                <div className="p-fluid grid">
                    <div className="field col-12 md:col-12">

                        <span style={{ textAlign: "left", textTransform: "uppercase" }}><h6><b>{getText("MODIFICA_MENU")}</b></h6></span>
                        {(nodeType === "M" || nodeType === "S") &&
                            <>
                                <div className="field col-12 md:col-12">
                                    {getText("NOME_IT")}
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="name" value={name_it} onChange={(e) => setName_it(e.target.value)} />
                                </div>
                                <div className="field col-12 md:col-12">
                                    {getText("NOME_EN")}
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} id="name" className="width500px p-inputtext-sm block mb-2 " value={name_en} onChange={(e) => setName_en(e.target.value)} />
                                </div>
                                <div className="field col-12 md:col-12">
                                    {getText("DESCRIZIONE_IT")}
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} className="width500px p-inputtext-sm block mb-2 " id="name" value={descrizione_it} onChange={(e) => setDescrizione_it(e.target.value)} />
                                </div>
                                <div className="field col-12 md:col-12">
                                    {getText("DESCRIZIONE_EN")}
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} id="name" className="width500px p-inputtext-sm block mb-2 " value={descrizione_en} onChange={(e) => setDescrizione_en(e.target.value)} />
                                </div>
                            </>
                        }

                        <div className="p-fluid grid">
                            <div className="field col-3 md:col-3">
                                <Button disabled={!validateForm()} label={getText("SALVA")} onClick={salva} icon="pi pi-save" />
                            </div>
                            <div className="field col-3 md:col-3">
                                <Button icon="pi pi-trash" label={getText("ELIMINA")} onClick={confirmOperation} ></Button>
                            </div>
                        </div>

                    </div>
                </div>
            }
        </>
    )
}

export default Menu
